module.exports = __webpack_public_path__ + "static/media/noti.64ab698b.svg";